/**
 * Client-side authentication configuration
 *
 * Environment variables (optional):
 * - REACT_APP_AUTH_CLIENT_ID: Override the OAuth client ID (default: 'qedit')
 *   For local development, use 'api-debugger' which has localhost redirect URIs configured.
 * - REACT_APP_AUTH_REDIRECT_URI: Override the redirect URI (e.g., for local dev)
 */

// Helper to determine the redirect URI
function getRedirectUri(): string {
    // Allow override via environment variable
    if (process.env.REACT_APP_AUTH_REDIRECT_URI) {
        return process.env.REACT_APP_AUTH_REDIRECT_URI;
    }
    // Default: use current origin + /code
    if (typeof window !== 'undefined') {
        return `${window.location.origin}/code`;
    }
    return '/code';
}

export const AUTH_CONFIG = {
    ISSUER: 'https://sso.koala.primbs.dev/realms/koala',
    CLIENT_ID: process.env.REACT_APP_AUTH_CLIENT_ID || 'qedit',
    REDIRECT_URI: getRedirectUri(),
    SCOPES: [
        'openid',
        'questionnaire_create',
        'questionnaire_read',
        'questionnaire_write',
        'questionnaire_view',
        'xauth_manage',
        'user_roles',
        'xauth_read',
        'profile_therapy_read',
        'profile_therapy_write',
        'aud_questionnaire',
        'aud_xauth',
        'aud_profile',
    ].join(' '),
    KEYCLOAK_AUDIENCE: 'questionnaire',
};

/**
 * Gets the authorization endpoint URL from the issuer
 */
export function getAuthorizationEndpoint(): string {
    return `${AUTH_CONFIG.ISSUER}/protocol/openid-connect/auth`;
}

/**
 * Gets the token endpoint URL from the issuer
 */
export function getTokenEndpoint(): string {
    return `${AUTH_CONFIG.ISSUER}/protocol/openid-connect/token`;
}

/**
 * Gets the userinfo endpoint URL from the issuer
 */
export function getUserInfoEndpoint(): string {
    return `${AUTH_CONFIG.ISSUER}/protocol/openid-connect/userinfo`;
}
